import { useState, useEffect } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import API from '@/amplify/api';

import { handleOnBlurSystemPromptModelSetting, handleChangeModel } from '@/component/productManagement/handler/VersionListHandler';
import { Chip } from '@material-ui/core';
import OverFlowTooltipWithCustomCss from '@/component/common/OverFlowTooltipWithCustomCss';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { checkModelUnsupport } from '../handler/OrganizationProfileHandler';

import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const AddModelSettingRow = ({
    currentAddList,
    modelSettingList,
    currentIndex,

    usingChatAI,
    usingAIAuto,
    setIsLoading,
    setIsEdited,
    setIsOpenModalReloadPage,
    addNewPanel,
    chatGPTModelList,
    isModelUnsupport,
    setIsModelUnsupport,

    onDeleteModelSetting,
    modelSettingDetail,
    key,
    setModelSettingAddList,
    setModelSettingList,
    setIsOpenAccessDeniedPopup
}) => {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [modelSetting, setModelSetting] = useState(modelSettingDetail);

    const [systemPrompt, setSystemPrompt] = useState(modelSettingDetail?.systemPrompt);
    const [interatorSystemPrompt, setInteratorSystemPrompt] = useState(modelSettingDetail?.interatorSystemPrompt);

    const [inputSystemPrompt, setInputSystemPrompt] = useState(modelSettingDetail?.systemPrompt?.linkPrompt);
    const [inputInteratorSystemPrompt, setInputInteratorSystemPrompt] = useState(modelSettingDetail?.interatorSystemPrompt?.linkPrompt);

    useEffect(() => {
        setInputSystemPrompt(modelSettingDetail?.systemPrompt?.linkPrompt);
        setInputInteratorSystemPrompt(modelSettingDetail?.interatorSystemPrompt?.linkPrompt);
        setSystemPrompt(modelSettingDetail?.systemPrompt);
        setInteratorSystemPrompt(modelSettingDetail?.interatorSystemPrompt);
    }, [modelSettingDetail]);

    const handleDisableSystemPromptInput = () => {
        return !usingChatAI || !usingAIAuto;
    }

    const renderFieldSystemPrompt = (
        systemPromptData,
        setSystemPromptData,
        inputSystemPromptData,
        setInputSystemPromptData,
        fieldKey
    ) => {
        return (
            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input prompt-basic-chip-ai-auto-column">
                {!systemPromptData?.value ||
                (systemPromptData?.value && systemPromptData?.error) ? (
                    <>
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 chip-org-profile"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        // comment for now
                        // onBlur={async e => {
                        //     setModelSettingAddList(prevList =>
                        //         prevList.map(item =>
                        //             updateItemPrompt(item, fieldKey, '', e.target.value)
                        //         )
                        //     );
                        //     let params = {
                        //         e: e,
                        //         API: API,
                        //         setIsLoading: setIsLoading,
                        //         systemPromptData: systemPromptData,
                        //         setIsEdited: setIsEdited,
                        //         setModelSettingAddList: setModelSettingAddList,
                        //         currentIndex: currentIndex,
                        //         fieldKey: fieldKey
                        //     }
                        //     await handleOnBlurSystemPromptModelSetting(params)
                        // }}
                        onBlur={e =>
                            handleSystemPromptBlur(e, {
                                API,
                                fieldKey,
                                setIsLoading,
                                systemPromptData,
                                setIsEdited,
                                setModelSettingAddList,
                                currentIndex,
                            })
                        }
                        helperText={''}
                        error={!Utils.isEmptyString(systemPromptData?.error)}
                        disabled={handleDisableSystemPromptInput()}
                        value={inputSystemPromptData}
                        onChange={e => {
                            setInputSystemPromptData(e.target.value);
                        }}
                    />
                    {!Utils.isEmptyString(systemPromptData?.error) && (
                        <div>
                            <span className='text-warning-chat-ai text-warning-model'>
                               {trI18n(systemPromptData?.error)}
                            </span>
                        </div>
                    )}
                    </>
                ) : (
                    <Chip
                        label={
                            <OverFlowTooltipWithCustomCss
                                value={systemPromptData?.value}
                                placement={'top'}
                            />
                        }
                        onClick={async () => {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(systemPromptData?.linkPrompt);
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={handleDisableSystemPromptInput() ? null : () => {
                            setSystemPromptData(prev => ({
                                ...prev,
                                error: '',
                                value: '',
                                linkPrompt: ''
                            }));
                            setIsEdited(true);
                            setInputSystemPromptData('');
                        }}
                        disableRipple={handleDisableSystemPromptInput()}
                        deleteIcon={handleDisableSystemPromptInput() ? null : (
                            <img
                                className={`basic-chip-delete-icon`}
                                src="/assets/image/delete-icon-rounded.svg"
                                alt="delete"
                            />
                        )}
                        className={`basic-chip chip-ai-auto top-4px ${
                            handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''
                        }`}
                    />
                )}
            </div>
        );
    };

    // render name model setting
    const renderModelList = (model, index) => {
        const errorMessage = [
            {
                condition: checkModelUnsupport(modelSetting?.model, chatGPTModelList),
                message: trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, modelSetting?.model)
            },
            {
                condition: modelSettingDetail.isModelBlank,
                message: trI18n('MSG-CM-REQUIRED-INPUT')
            },
            {
                condition: modelSettingDetail.hasDuplicate,
                message: trI18n('MSG_AI_MODEL_DUPLICATE')
            }
        ].find(item => item.condition)?.message;
        return (
            <>
                <TextField
                    className="form-control form-control--wrap form-control--hg40 width-70 model-setting-name"
                    select
                    variant="outlined"
                    name="selectedChatGPTModel"
                    value={`${modelSetting?.model || ''}`}
                    defaultValue={`${modelSetting?.model || ''}`}
                    SelectProps={{
                        value: `${modelSetting?.model || ''}`,
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }
                    }}
                    disabled={handleDisableSystemPromptInput()}
                    error={errorMessage}
                    onChange={e => {
                        let dataChange = {
                            modelSetting, 
                            setModelSetting, 
                            currentAddList, 
                            currentIndex, 
                            setModelSettingAddList,
                            modelSettingList,
                            setModelSettingList,
                            chatGPTModelList,
                            setIsEdited
                        }
                        handleChangeModel(e, dataChange)
                    }}
                >
                    {chatGPTModelList?.map(chatGPT => {
                        return (
                            <MenuItem
                                className={
                                    chatGPT?.status ===
                                        Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT &&
                                    'd-hidden'
                                }
                                key={`chatGPT-${chatGPT.id}`}
                                value={chatGPT.id}
                            >
                                <OverFlowTooltipWithTabsMui
                                    className={`className-${chatGPT.id}`}
                                    value={chatGPT.id}
                                >
                                    {chatGPT.id}
                                </OverFlowTooltipWithTabsMui>
                            </MenuItem>
                        );
                    })}
                </TextField>
                {errorMessage && (
                    <div>
                        <span className="text-warning-chat-ai text-warning-model">{errorMessage}</span>
                    </div>
                )}
            </>
        );
    };
  
    const updateItemPrompt = (item, fieldKey, newValue, newLinkPrompt) => {
        if (item.id !== currentIndex) return item;
        return {
            ...item,
            [fieldKey]: {
                ...item[fieldKey],
                value: newValue,
                linkPrompt: newLinkPrompt
            }
        };
    };

    const handleSystemPromptBlur = async (e, data) => {
        const { fieldKey } = data;

        setModelSettingAddList(prevList =>
            prevList.map(item =>
                updateItemPrompt(item, fieldKey, '', e.target.value)
            )
        );

        await handleOnBlurSystemPromptModelSetting({
            e,
            ...data
        });
    };

    return (
        <TableRow key={currentIndex}>
            {/* chatGptModel */}
            <TableCell className='table-row-top'>
                {renderModelList()}
            </TableCell>
            {/* systemPrompt */}
            <TableCell className='table-row-top'>
                {
                    renderFieldSystemPrompt(
                        systemPrompt,
                        setSystemPrompt,
                        inputSystemPrompt,
                        setInputSystemPrompt,
                        Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT
                    )
                }
            </TableCell>
            
            {/* remove item add model setting */}
            <TableCell className='table-row-top'>
                <div className={`editModelSettingGroupBtn ${handleDisableSystemPromptInput()? ' groupBtnEditModelStting-disable': ''}`}>
                    <IconButton
                        className="erase btnDeleteModelSetting"
                        disabled={handleDisableSystemPromptInput()}
                        onClick={onDeleteModelSetting}
                    >
                        <img src="/assets/image/delete-icon.svg" alt="" />
                    </IconButton>
                </div>
            </TableCell>
        </TableRow>
    );
}
export default AddModelSettingRow;

AddModelSettingRow.propTypes = {
    currentAddList: PropTypes.any,
    modelSettingList: PropTypes.any,
    currentIndex: PropTypes.any,
    usingChatAI: PropTypes.any,
    usingAIAuto: PropTypes.any,
    setIsLoading: PropTypes.any,
    setIsEdited: PropTypes.any,
    setIsOpenModalReloadPage: PropTypes.any,
    addNewPanel: PropTypes.any,
    chatGPTModelList: PropTypes.any,
    isModelUnsupport: PropTypes.any,
    setIsModelUnsupport: PropTypes.any,
    onDeleteModelSetting: PropTypes.any,
    modelSettingDetail: PropTypes.any,
    key: PropTypes.any,
    setModelSettingAddList: PropTypes.any,
    setModelSettingList: PropTypes.any,
    setIsOpenAccessDeniedPopup: PropTypes.any,
};